export default __webpack_public_path__ + "static/media/avatar_indian_boy3.cc8a4ae8.mp3";